import React, { useState, useEffect, createRef } from "react";
import HedonicSpider from "../charts/HedonicSpider";
import HedonicScatter from "../charts/HedonicScatter";
// import FakeSpiderData from '../../pages/FakeSpiderData';
// import FakeScatterData from '../../pages/FakeScatterData';
import CampaignCard from "../campainCard/CampaignCard";
import TopBox from "../topBox/TopBox";
import Spinner from "../common/spinner/Spinner";
import BarPlots from "../charts/BarPlots";
import { useScreenshot, createFileName } from "use-react-screenshot";

import "./Perception.css";

const Perception = ({ perception, metadata }) => {
  const [cards, setCards] = useState(perception.Result);
  const [cardSelected, setCardSelected] = useState(perception.Result[0]);

  const [perceptionData, setPerceptionData] = useState({
    isLoading: true,
    barPlots: [],
    scatterChart: [perception.Scatter_plot],
  });

  const handleSelected = (card) => {
    setCardSelected(card);
  };

  useEffect(() => {
    var barPlotsChartDatas = perception.Bar_plots;

    var barPlotProduct = barPlotsChartDatas
      .filter((item) => {
        return item.Product == cardSelected.Product;
      })
      .map((item) => item.Bar_plot);

    var clonePerceptionData = {
      ...perceptionData,
      // barPlots: barPlotProduct,
      isLoading: false,
    };

    function sortObj(obj) {
      return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
          result[key] = obj[key];
          return result;
        }, {});
    }

    var newBarPlots = barPlotProduct[0].sort(function (a, b) {
      var textA = a.Attribute_group.toLowerCase();
      var textB = b.Attribute_group.toLowerCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    var clonePerceptionData = {
      ...perceptionData,
      barPlots: newBarPlots,
      isLoading: false,
    };
    setPerceptionData(clonePerceptionData);
  }, [cardSelected]);

  var objPlot = {};
  if (perceptionData.barPlots.length > 0) {
    var allBarPlots = perceptionData.barPlots;

    for (let i = 0; i < allBarPlots.length; i++) {
      var curPlot = allBarPlots[i];
      if (objPlot[curPlot.Attribute_group] == undefined) {
        objPlot[curPlot.Attribute_group] = [];
      }
      objPlot[curPlot.Attribute_group].push(curPlot);
    }
  }

  const ref = createRef(null);
  const [image, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const download = (image, { name = "img", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenshot = () => takeScreenShot(ref.current).then(download);

  // var result =

  return (
    <>
      {perceptionData.isLoading == true ? (
        <Spinner size="medium" color="grey" position="center" />
      ) : (
        <div className="container">
          <div className="container__cards">
            {cards.map((card) => (
              <CampaignCard
                card={card}
                key={card.PRODUCT}
                onSelected={(card) => handleSelected(card)}
                cardSelected={cardSelected}
              />
            ))}
          </div>
          <div className="boxes">
            <HedonicScatter
              data={perceptionData.scatterChart}
              metadata={metadata}
              cardSelected={cardSelected}
            />
          </div>
          <button onClick={downloadScreenshot} class="btn">
            Download
          </button>
          <div class="barPlots" ref={ref}>
            <div className="legend">
              <div className="legend_box">
                <div className="legend_box--candidat"></div>
                <div className="legend_box--title">
                  Candidate {cardSelected.Product}
                </div>
              </div>
              <div className="legend_box">
                <div className="legend_box--moyenne"></div>
                <div className="legend_box--title">
                  Moyenne {metadata.Client}
                </div>
              </div>
            </div>
            <div className="barPlots-container">
              {Object.keys(objPlot).map((key, index) => {
                return (
                  <BarPlots
                    barPlots={objPlot[key]}
                    key={index}
                    cardSelected={cardSelected}
                    metadata={metadata}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Perception;
